import { createAppKit } from '@reown/appkit/react'

import { WagmiProvider } from 'wagmi'
import { AppKitNetwork, base, baseSepolia } from '@reown/appkit/networks'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { ReactNode } from 'react'

const queryClient = new QueryClient()

const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID
const isProd = process.env.REACT_APP_STATUS_ENV === 'prod'

const metadata = {
  name: 'ProjectTest',
  description: 'AppKit Example',
  url: 'https://reown.com/appkit',
  icons: ['https://assets.reown.com/reown-profile-pic.png'],
}

const networks = isProd
  ? ([base] as [AppKitNetwork, ...AppKitNetwork[]])
  : ([baseSepolia] as [AppKitNetwork, ...AppKitNetwork[]])

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId: projectId || '',
  ssr: false,
})

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId: projectId || '',
  metadata,
  features: {
    analytics: true,
    email: false,
    socials: false,
    send: false,
    swaps: false,
    onramp: false,
  },
})

interface IProps {
  children: ReactNode
}

export function AppKitProvider({ children }: IProps) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}
